import { render, staticRenderFns } from "./CompanyComments.vue?vue&type=template&id=726f61ee&scoped=true&"
import script from "./CompanyComments.vue?vue&type=script&lang=js&"
export * from "./CompanyComments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyComments.vue?vue&type=style&index=0&id=726f61ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f61ee",
  null
  
)

export default component.exports